import { type EntityState } from '@ngrx/entity';

import {
  type CanvasElement,
  type CanvasElementId,
  type SlotAlignment,
  type SlotId,
} from '@blaze-runtime/engine-domain';

import { hasSlots } from '../../canvas-elements/element-model/element-props-guards';
import {
  getHorizontalAlignment,
  getVerticalAlignment,
} from '../../canvas-elements/element-model/slots';

export function setSlotAlignmentMutably(
  draft: EntityState<CanvasElement>,
  elementId: CanvasElementId,
  slotId: SlotId,
  horizontalAlignment?: SlotAlignment['horizontal'],
  verticalAlignment?: SlotAlignment['vertical'],
): void {
  const element = draft.entities[elementId];

  if (!element) {
    throw new Error(`Could not find element id ${elementId}`);
  }

  if (!hasSlots(element)) {
    throw new Error(`Element id ${elementId} is missing slots`);
  }

  const slot = element.slots[slotId];
  if (!slot) {
    throw new Error('Could not find slot');
  }

  const previousHorizontal = getHorizontalAlignment(slot.alignment);
  const previousVertical = getVerticalAlignment(slot.alignment);

  slot.alignment = {
    horizontal: horizontalAlignment || previousHorizontal,
    vertical: verticalAlignment || previousVertical,
    syncVerticalLineAlignment: true,
  };
}
